module.exports = __webpack_public_path__ + "img/blog-2.e26f2d1e.png";